import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import favicon from "./assets/favicon.png";
import AppRoot from "./AppRoot";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <BrowserRouter>
        <AppRoot />
      </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();

// Set favicon from bundled asset (allows using src/assets/favicon.png)
if (typeof document !== "undefined") {
  const link = document.querySelector("link[rel='icon']");
  if (link) link.href = favicon;
}
